import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { useSelector } from '../../components/common/react-redux-hooks';

const CASummaryEntForthSectInfo = ({ markets }) => {
  const { mriTopMarkets } = useSelector(state => ({
    mriTopMarkets: state.contractAdmin.mriTopMarkets,
  }));

  const [selectedMRIMarket, setSelectedMRIMarktet] = useState([]);

  useEffect(() => {
    const filterIds = markets.find(item => item.studySource === 2);
    const emptyCheck = isEmpty(filterIds);
    if (emptyCheck === false) {
      if (filterIds.studySource === 2) {
        const result = mriTopMarkets.filter(obj =>
          filterIds.ids.includes(obj.id)
        );
        setSelectedMRIMarktet(result);
      }
    }
  }, []);

  return (
    <React.Fragment>
      <div className="ent-section-header-codes">
        <div>
          <span className="summary-sp-col">MRI Markets</span>
        </div>
      </div>
      {selectedMRIMarket.length > 0 &&
        selectedMRIMarket.map(item => {
          const title = item.dmaDesc;
          return (
            <div className="access-codes-list" title={title}>
              <span>{item.dmaDesc}</span>
            </div>
          );
        })}
    </React.Fragment>
  );
};

CASummaryEntForthSectInfo.propTypes = {
  markets: PropTypes.arrayOf(PropTypes.object),
};

export default CASummaryEntForthSectInfo;
